import { z } from "zod";
export const FacilityType = z.enum(["PORT", "PLATFORM", "FISH_FARM", "DISCHARGE_TERMINAL", "DISCHARGE_STS", "ANCHORAGE"]);
export const GetAllFacilitiesArgs = z.object({
    types: z.array(FacilityType),
});
export const Facility = z.object({
    name: z.string(),
    id: z.number(),
    latitude: z.number(),
    longitude: z.number(),
    radiusM: z.number(),
    type: FacilityType,
});
export const SetFacilityRadius = z.object({
    facilityId: z.number(),
    radiusM: z.number(),
});
//# sourceMappingURL=facilities.js.map